import React from 'react';
import { useParams } from 'react-router-dom';
import App from './App';
import Spinner from "react-bootstrap/Spinner";
import MetaHelmet from './components/MetaHelmet';
import { getMetaTags } from './utils/metaConfig';
import { useEditionData, useAiBrandingData, useRedirectToCurrentEdition } from './hooks/useEditionData';

const DynamicPage = () => {
  const { editionName: paramEditionName } = useParams();
  const editionName = paramEditionName ? paramEditionName.toLowerCase() : null;

  const { pageData, loading, error } = useEditionData(editionName);
  const aiBrandingData = useAiBrandingData();

  useRedirectToCurrentEdition(error && !loading, editionName);

  if (loading || !pageData || !aiBrandingData) {
    return <Spinner animation="border" role="status" />;
  }

  const meta = getMetaTags({
    pageType: 'edition',
    editionName,
    metaData: pageData.metaData,
    domain: process.env.REACT_APP_DOMAIN,
    cdnLink: process.env.REACT_APP_CDN_LINK,
    publicUrl: process.env.PUBLIC_URL,
  });

  return (
    <>
      <MetaHelmet {...meta} />
      <App pageData={pageData} aiBrandingData={aiBrandingData} />
    </>
  );
};

export default DynamicPage;
